<template>
    <VApp>
        <AppHeader />
        <VMain class="pa-6">
            <RouterView />
        </VMain>
        <AppFooter />
        <ToastContainer />
    </VApp>
</template>

<script lang="ts" setup>
import AppFooter from '@/components/default/AppFooter.vue'
import AppHeader from '@/components/default/AppHeader/AppHeader.vue'
import ToastContainer from '@/components/default/ToastContainer/ToastContainer.vue'
</script>
